import { css, styled } from "styled-components";
// const { Step } = Steps;

export const StyledBox = styled.div`
  background: var(--white);
  width: 40rem;
  position: absolute;
  margin-top: 8vh;
  right: 8rem;
  background: white;
  @media (max-width: 1300px) {
    right: 2rem;
  }
  @media (max-width: 1082px) {
    padding: 0;
    right: 0;
    margin-top: 40px;
  }
  @media (max-width: 698px) {
    width: 100%;
    padding: 0;
    right: 0;
    margin-top: 30px;
  }
  @media (max-width: 573px) {
    width: 100%;
    padding: 0;
    right: 0;
  }
  @media (max-width: 370px) {
    width: 100%;
    padding: 0;
    right: 0;
  }
  @media (max-width: 320px) {
    width: 100%;
    padding: 0;
    right: 0;
  }
`;
